import { Client } from "./types";

const keys = {
  all: () => ["clients"] as const,
  one: (id: Client["_id"]) => [...keys.all(), id] as const,
};

export default keys;
